import { useContext, useEffect } from 'react';
import { AlertContext } from '../context/AlertContext';
import { useTranslation } from 'react-i18next';
import { useGetProjectWorkersQuery } from '../store/services/api';

export const useProjectWorkers = () => {
  const { data, error, isFetching } = useGetProjectWorkersQuery();
  const { setMessage } = useContext(AlertContext);
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      setMessage(t('errors.fetchProjectWorkers', { error }), 'error');
    }
  }, [error]);

  return { workers: data ? data.data : [], isFetching };
};
